import { type Brand } from '@/consts/brands';

/**
 * @deprecated
 * Gets the brand from the URL; for the cases where
 * we are not in a React component, such as the csrfHandler
 */
export const getBrandFromUrl = (): Brand => {
  const brand = window?.location?.host?.toLowerCase().includes('withagency')
    ? 'agency'
    : 'curology';

  return brand as Brand;
};
